
        'use strict';
        import { Component,  Input, OnInit, Inject} from 'ng-metadata/core';
        import {getViewSvg} from "../appConfig/customizationConfig";

        const some = require('lodash/some');

        @Component({
            selector: 'prm-icon',
            templateUrl: 'components/icon/icon.html',
            legacy: {transclude: true}
        })

        export class PrmIcon implements OnInit {
            @Input() private class:string;
            @Input() private iconType:string;
            @Input() private iconDefinition:string;
            @Input() private svgIconSet:string;
            @Input() private prmAriaLabel:string;
            @Input() private ariaLabel:string;
            @Input() public displayMode:string;
            private isCustom = false;
            
            //keep the $element here - customers are using to customize their icons as a hack
            constructor(@Inject('$element') private $element: JQuery,
                        @Inject('$mdIcon') private $mdIcon) {
            }


            private ngOnInit(){
                if (getViewSvg()) {
                    let id: string = 'custom-ui:' + this.iconDefinition;
                    this.$mdIcon(id).then((iconEl)=>{
                        if (iconEl) {
                            this.isCustom = true;
                        }
                    }).catch(angular.noop);
                }
                this.prmAriaLabel = (typeof this.prmAriaLabel === 'undefined' && typeof this.ariaLabel === 'undefined') ? 'icon-'+ this.iconDefinition : this.prmAriaLabel || this.ariaLabel;

            }

            public isEmailMode() {
                return this.displayMode === 'email';
            }

        }


// WEBPACK FOOTER //
// ./src/main/webapp/components/icon/icon.directive.ts